import { graphql } from 'src/graphql';

export const EvidenceFeedbackQuery = graphql(`
  query GetEvidenceFeedback($evidenceId: String!, $chatMessageId: String!) {
    evidenceFeedback(evidenceId: $evidenceId, chatMessageId: $chatMessageId) {
      id
      evidenceId
      chatMessageId
      type
      issueType
      details
    }
  }
`);
